module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/ajax-loader/ajax-loader.component.scss
// module id = ./src/app/components/tools/ajax-loader/ajax-loader.component.scss
// module chunks = main